import { ShoppingBag, Check } from "lucide-react";
import { Link } from "react-router-dom";
import { useCart } from "../lib/cart";
import { FILE_BASE } from "../lib/api";

export default function PhotoCard({ photo, onClick, hidePhotographer = false }) {
  const { has, add, remove } = useCart();
  const inCart = has(photo.id);
  const numbers = photo.tags_overridden
    ? (photo.manual_numbers || [])
    : [...new Set([...(photo.detected_numbers || []), ...(photo.manual_numbers || [])])];

  const toggle = (e) => {
    e.stopPropagation();
    if (inCart) remove(photo.id);
    else add(photo);
  };

  const stop = (e) => e.stopPropagation();

  return (
    <div
      className="card-surface group relative overflow-hidden cursor-pointer gallery-item"
      onClick={onClick}
      data-testid={`photo-card-${photo.id}`}
    >
      <div className="relative aspect-[4/3] bg-[#1a1a1a] overflow-hidden">
        <img
          src={`${FILE_BASE}${photo.thumb_url}`}
          alt={photo.event_name || "Foto"}
          loading="lazy"
          decoding="async"
          fetchpriority="low"
          className="w-full h-full object-cover"
        />
        {numbers.length > 0 && (
          <div className="absolute top-2 left-2 flex gap-1 flex-wrap max-w-[80%]">
            {numbers.slice(0, 3).map((n) => (
              <span
                key={n}
                className="bg-brand text-white text-xs font-bold font-display uppercase px-2 py-1 tracking-wider"
                data-testid={`bib-tag-${n}`}
              >
                #{n}
              </span>
            ))}
          </div>
        )}
        {/* Photographer logo badge — bottom-left, small, semi-transparent white bg */}
        {photo.photographer_logo_url && (
          <div
            className="absolute bottom-2 left-2 bg-white/85 backdrop-blur-sm rounded-sm px-1.5 py-1 max-w-[40%]"
            data-testid={`photog-logo-${photo.id}`}
          >
            <img
              src={`${FILE_BASE}${photo.photographer_logo_url}`}
              alt={photo.photographer_name || ""}
              className="block max-h-5 w-auto object-contain"
            />
          </div>
        )}
        <button
          onClick={toggle}
          className={`absolute bottom-2 right-2 ${
            inCart ? "bg-green-600 hover:bg-green-700" : "bg-brand hover:bg-brand-hover"
          } text-white p-2 transition-all transform translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 ${
            inCart ? "translate-y-0 opacity-100" : ""
          }`}
          aria-label={inCart ? "Ta bort från varukorg" : "Lägg i varukorg"}
          data-testid={`add-cart-${photo.id}`}
        >
          {inCart ? <Check className="w-4 h-4" /> : <ShoppingBag className="w-4 h-4" />}
        </button>
      </div>
      <div className="p-3 flex items-center justify-between gap-2">
        <div className="min-w-0">
          {!hidePhotographer && (
            photo.photographer_slug ? (
              <Link
                to={`/fotograf/${photo.photographer_slug}`}
                onClick={stop}
                className="text-xs text-white/70 hover:text-brand uppercase tracking-wider truncate block"
                data-testid={`photo-card-photographer-${photo.id}`}
              >
                {photo.photographer_name || "Fotograf"}
              </Link>
            ) : (
              <p className="text-xs text-white/50 uppercase tracking-wider truncate">
                {photo.photographer_name || "Fotograf"}
              </p>
            )
          )}
          <p className="text-sm text-white truncate">{photo.event_name}</p>
        </div>
        <p className="font-display font-bold text-brand whitespace-nowrap">
          {photo.price_sek?.toFixed(0)} kr
        </p>
      </div>
    </div>
  );
}
